// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1nsEi","backToLoginInForm":"styles_backToLoginInForm__dfbZW","spinnerContainer":"styles_spinnerContainer__pfdZ6","hide":"styles_hide__1Hn7x"};